<template>
  <vx-card title="Verificación judicial">
    <!-- El titular es el resumen. Con dieciséis fuentes en verde, listarlas
         es ruido que entierra el único rojo cuando aparezca. -->
    <div class="gw-resumen">
      <template v-if="conHallazgo.length">
        <div class="gw-resumen-alerta">
          {{ conHallazgo.length }} de {{ consultadas.length }}
          {{ consultadas.length === 1 ? 'fuente consultada' : 'fuentes consultadas' }}
          con novedades que te sugerimos revisar
        </div>
      </template>
      <template v-else-if="consultadas.length">
        <div class="gw-resumen-ok">
          {{ consultadas.length }} de {{ consultadas.length }}
          {{ consultadas.length === 1 ? 'fuente consultada' : 'fuentes consultadas' }},
          sin hallazgos
        </div>
      </template>
      <template v-else>
        <div class="gw-resumen-neutro">Todavía no hay fuentes consultadas</div>
      </template>

      <!-- No se dice "20 de 20" cuando cuatro no tienen información: seria un
           numero que no se puede sostener si el cliente pregunta. -->
      <div v-if="sinInformacion.length" class="gw-resumen-pendiente">
        {{ sinInformacion.length }}
        {{ sinInformacion.length === 1 ? 'fuente sin información' : 'fuentes sin información' }}
        todavía
      </div>
    </div>

    <!-- Lo que sí tiene novedad va siempre a la vista, nunca plegado -->
    <ul v-if="conHallazgo.length" class="gw-hallazgos">
      <li v-for="(f, i) in conHallazgo" :key="'h' + i">
        <vs-icon size="small" icon="report_problem" color="danger"></vs-icon>
        <span>{{ f.name }}</span>
      </li>
    </ul>

    <div v-if="plegables.length" class="gw-desplegable">
      <button type="button" class="gw-toggle" @click="abierto = !abierto">
        <span class="gw-toggle-flecha" :class="{ 'gw-toggle-flecha--abierta': abierto }">▸</span>
        {{ abierto ? 'Ocultar el detalle' : textoDesplegar }}
      </button>

      <div v-if="abierto" class="gw-detalle">
        <p class="gw-detalle-intro">
          Estas son las bases de datos que se consultan para saber si el
          candidato tiene registros negativos.
        </p>

        <ul class="gw-lista">
          <li v-for="(f, i) in plegables" :key="'p' + i" class="gw-lista-item">
            <vs-icon
              size="small"
              :icon="f.photo ? 'done' : 'schedule'"
              :color="f.photo ? 'success' : 'warning'"
            ></vs-icon>
            <span :class="{ 'gw-lista-pendiente': !f.photo }">{{ f.name }}</span>
          </li>
        </ul>

        <ul class="gw-leyenda">
          <li><vs-icon size="small" icon="done" color="success"></vs-icon> No se presentan registros negativos</li>
          <li><vs-icon size="small" icon="report_problem" color="danger"></vs-icon> Hay novedades que te sugerimos revisar</li>
          <li><vs-icon size="small" icon="schedule" color="warning"></vs-icon> La información no ha sido obtenida aún</li>
        </ul>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  name: "ProjectJudicialVerification",
  props: {
    project: Object,
  },

  data() {
    return {
      abierto: false,
    };
  },

  computed: {
    fuentes() {
      var p = this.project || {};
      return Array.isArray(p.judicial_verification) ? p.judicial_verification : [];
    },

    // `photo` dice si quedó evidencia capturada de la consulta. El componente
    // ya trataba su ausencia como "sin información": antes esas filas
    // simplemente se descartaban y no aparecían en ninguna parte, aunque la
    // leyenda prometía ese tercer estado.
    consultadas() {
      return this.fuentes.filter(function (f) { return f.photo === true; });
    },

    sinInformacion() {
      return this.fuentes.filter(function (f) { return f.photo !== true; });
    },

    conHallazgo() {
      return this.consultadas.filter(function (f) { return f.verification === true; });
    },

    sinHallazgo() {
      return this.consultadas.filter(function (f) { return f.verification !== true; });
    },

    // Se pliega lo que no exige atención: lo limpio y lo que todavía no tiene
    // información.
    plegables() {
      return this.sinHallazgo.concat(this.sinInformacion);
    },

    // "Ver las 20 fuentes restantes" confunde cuando 20 es tambien el total.
    textoDesplegar() {
      var n = this.plegables.length;
      return n === 1 ? "Ver el detalle de la fuente" : "Ver el detalle de las " + n + " fuentes";
    },
  },
};
</script>

<style scoped>
.gw-resumen {
  margin: -4px 0 4px;
}
.gw-resumen-ok {
  font-size: 15px;
  font-weight: 700;
  color: #2e7d52;
}
.gw-resumen-alerta {
  font-size: 15px;
  font-weight: 700;
  color: #c0392b;
}
.gw-resumen-neutro {
  font-size: 15px;
  font-weight: 700;
  color: #6b6b6b;
}
.gw-resumen-pendiente {
  font-size: 12.5px;
  color: #9a6d12;
  margin-top: 4px;
}

.gw-hallazgos {
  list-style: none;
  margin: 14px 0 0;
  padding: 12px 14px;
  background: #fcebe9;
  border: 1px solid #f3d6d2;
  border-radius: 9px;
}
.gw-hallazgos li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #3b3b3b;
  padding: 3px 0;
}

.gw-desplegable {
  margin-top: 16px;
}
.gw-toggle {
  background: none;
  border: none;
  padding: 0;
  font-size: 13px;
  color: #5f0091;
  font-weight: 600;
  cursor: pointer;
}
.gw-toggle:hover {
  text-decoration: underline;
}
.gw-toggle-flecha {
  display: inline-block;
  transition: transform 0.15s ease;
  margin-right: 4px;
}
.gw-toggle-flecha--abierta {
  transform: rotate(90deg);
}

.gw-detalle {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #f0f0f0;
}
.gw-detalle-intro {
  font-size: 12px;
  color: #9a9a9a;
  margin: 0 0 12px;
  max-width: 72ch;
}
.gw-lista {
  list-style: none;
  margin: 0;
  padding: 0;
}
.gw-lista-item {
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 13px;
  color: #3b3b3b;
  padding: 6px 0;
  border-bottom: 1px solid #f7f7f7;
}
.gw-lista-item:last-child {
  border-bottom: none;
}
.gw-lista-pendiente {
  color: #9a9a9a;
}
.gw-leyenda {
  list-style: none;
  margin: 16px 0 0;
  padding: 12px 0 0;
  border-top: 1px solid #f0f0f0;
}
.gw-leyenda li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11.5px;
  color: #9a9a9a;
  padding: 2px 0;
}
</style>
